export default __webpack_public_path__ + "static/media/Sielanka_39.b646f316.jpg";